// extracted by mini-css-extract-plugin
export var fadeInOut = "_2j-3";
export var icon = "_2j-4";
export var savedIndicator = "_2j-2";
export var savingIndicator = "_2j-0";
export var spin = "_2j-1";